/**
 * JUB-160: package recommendation from two quick answers on the preview.
 *
 * Mirrors PlanService limits/features: Free = up to 50 confirmed guests, no
 * gifts; Standard = up to 200 guests + Plicul Digital (direct contributions);
 * Premium = unlimited guests + gift list. The recommendation never forces a
 * purchase — "Rămân pe Gratuit" stays available.
 */
import type { GiftsAnswer, GuestsAnswer, PlanChoice } from "./types";

export function recommendPlan(answers: { guests: GuestsAnswer | null; gifts: GiftsAnswer | null }): PlanChoice | null {
  const { guests, gifts } = answers;
  if (!guests || !gifts) return null;
  if (guests === "over_200" || gifts === "list") return "premium";
  if (guests === "up_to_200" || gifts === "envelope") return "standard";
  return "free";
}

/**
 * Which plan the card proposes. Once both questions are answered, the
 * recommendation from those answers decides — a plan picked at registration
 * (planSelectionStore / ?buyPlan=) must never hide that the stated needs
 * call for another plan (e.g. pending Standard + more than 200 guests →
 * Premium). Until then the paid registration plan is the fallback.
 */
export function preselectedPlan(
  recommended: PlanChoice | null,
  pending: PlanChoice | null | undefined,
): PlanChoice | null {
  if (recommended) return recommended;
  return pending && pending !== "free" ? pending : null;
}
